import Page from './Page';
import AdminOnly from '../../components/AdminOnly';

function AdminContainer() {
  return (
    <AdminOnly>
      <Page />
    </AdminOnly>
  );
}

export default AdminContainer;
